import Order from '@/models/Order';

export const orderPaymentObserverMixin = {
  props: {
    orderPaymentObserverMixin_interval_delay: {
      type: Number,
      default: 5000
    }
  },

  data() {
    return {
      orderPaymentObserverMixin_orderId: null,
      orderPaymentObserverMixin_orderPullingInterval: null,
      orderPaymentObserverMixin_event: new EventTarget()
    };
  },

  computed: {
    $_orderPaymentObserverMixin_order() {
      return Order.query()
        .with(['latest_payment', 'payments'])
        .where('id', this.orderPaymentObserverMixin_orderId)
        .first();
    }
  },

  methods: {
    $_orderPaymentObserverMixin_startOrderPulling() {
      if (this.orderPaymentObserverMixin_orderPullingInterval) return;

      console.log('Starting order pulling interval');

      this.orderPaymentObserverMixin_orderPullingInterval = setInterval(() => {
        this.$_orderPaymentObserverMixin_pullOrder();
      }, this.orderPaymentObserverMixin_interval_delay);
    },

    $_orderPaymentObserverMixin_stopOrderPulling() {
      if (this.orderPaymentObserverMixin_orderPullingInterval) {
        console.log('Stopping order pulling interval');

        clearInterval(this.orderPaymentObserverMixin_orderPullingInterval);
      }

      this.orderPaymentObserverMixin_orderPullingInterval = null;
    },

    async $_orderPaymentObserverMixin_pullOrder() {
      await Order.api().fetchOrder(this.orderPaymentObserverMixin_orderId);

      const order = this.$_orderPaymentObserverMixin_order;

      if (
        order &&
        order.status === 'PENDING' &&
        order.latest_payment?.status === 'PENDING' &&
        this.$_datetimeMixin_isLessThanNow(new Date(order.latest_payment.due_date))
      ) {
        console.log('Order has been expired, stop pulling order.');

        return this.$_orderPaymentObserverMixin_stopOrderPulling();
      }

      if (
        order &&
        order.status === 'SUCCESS' &&
        (order.latest_payment?.status === 'SUCCESS' ||
          order.payments.some((payment) => payment.status === 'SUCCESS'))
      ) {
        console.log('Order has been paid successfully.');

        this.$_orderPaymentObserverMixin_stopOrderPulling();

        this.orderPaymentObserverMixin_event.dispatchEvent(
          new CustomEvent('order-paid', { detail: order })
        );
      }
    }
  },

  beforeDestroy() {
    if (this.orderPaymentObserverMixin_orderPullingInterval)
      this.$_orderPaymentObserverMixin_stopOrderPulling();
  }
};
